module.exports = __webpack_public_path__ + "img/50.cc94b4a9.svg";